import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate } from "react-router-dom";

export default function PracticeHistory() {
  const [rows, setRows] = useState([]);
  const [setsMap, setSetsMap] = useState({});
  const [loading, setLoading] = useState(true);

  const nav = useNavigate();

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      setLoading(true);

      // 🔥 SAME AS MOBILE APP
      const [historyRes, setsRes] = await Promise.all([
        api.get("/study/practice-history"),
        api.get("/study/practice-sets"),
      ]);

      const history = historyRes.data || [];
      const sets = setsRes.data || [];

      // 🔑 Map practice_set_id -> title + subject
      const map = {};
      sets.forEach((s) => {
        map[s.id] = {
          title: s.name,
          subject: s.subject_name || "—",
        };
      });

      setSetsMap(map);
      setRows(history);
    } catch (err) {
      console.error("Failed to load practice history", err);
      setRows([]);
      setSetsMap({});
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <p style={{ padding: 30 }}>⏳ Loading practice history...</p>;
  }

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardStyle}>
          {/* ================= HEADER ================= */}
          <div style={headerRow}>
            <img src="/logo.png" alt="EduAt10" style={logoStyle} />

            <button
              onClick={() => nav("/user/dashboard")}
              style={backBtnStyle}
            >
              ← Back to Dashboard
            </button>
          </div>

          <h2>📊 Practice History</h2>

          {rows.length === 0 ? (
            <p style={{ marginTop: 20, color: "#64748b" }}>
              No practice results found
            </p>
          ) : (
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginTop: 15,
              }}
            >
              <thead>
                <tr style={{ background: "#e5e7eb" }}>
                  <th style={th}>Practice Set</th>
                  <th style={th}>Subject</th>
                  <th style={th}>Score</th>
                  <th style={th}>Date</th>
                </tr>
              </thead>

              <tbody>
                {rows.map((r) => {
                  const meta = setsMap[r.practice_set_id] || {};

                  return (
                    <tr key={r.attempt_id}>
                      <td style={td}>{meta.title || "—"}</td>
                      <td style={td}>{meta.subject || "—"}</td>
                      <td style={td}>
                        {r.score}/{r.total_questions}
                      </td>
                      <td style={td}>
                        {new Date(r.submitted_at).toLocaleDateString()}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const overlayStyle = {
  minHeight: "100vh",
  backgroundColor: "rgba(0,0,0,0.25)",
  padding: 20,
};

const cardStyle = {
  maxWidth: 1100,
  margin: "auto",
  background: "rgba(255,255,255,0.95)",
  borderRadius: 16,
  padding: 30,
};

const headerRow = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 12,
  marginBottom: 20,
};

const logoStyle = {
  width: 120,
};

const backBtnStyle = {
  padding: "10px 16px",
  background: "#e2e8f0",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
};

const th = {
  border: "1px solid #ddd",
  padding: 10,
  textAlign: "left",
  fontWeight: 700,
};

const td = {
  border: "1px solid #ddd",
  padding: 10,
  fontSize: 14,
};
